<template>
  <div class="locations-map-container">
    <div class="locations-map">
      <div id="map" class="map-container"></div>
    </div>
  </div>
</template>
  
  <script>
import mapboxgl from "mapbox-gl";

export default {
  data() {
    return {
      latitude: -117.00030511809604,
      longitude: 32.5159194255379,
      zoom: 16,
      map: null,
    };
  },
  name: "LocationsMap",
  mounted() {
    this.initializeMap();
  },
  methods: {
    initializeMap() {
      mapboxgl.accessToken =
        "pk.eyJ1Ijoic3BhY2ViYXItdGlqdWFuYSIsImEiOiJjbHc4ZDByM2gyZmdoMmtxY2V4YXAzYmxhIn0.4N8G7fWzuN_Jt0Zm5i97qg";

      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v12",
        center: [this.latitude, this.longitude],
        zoom: this.zoom,
      });

      // Añade un marcador al mapa en la ubicación inicial

      var el = document.createElement("div");
      el.className = "marker";

      let Marker = new mapboxgl.Marker(el)
        .setLngLat([this.latitude, this.longitude])
        .addTo(this.map);
    },
  },
};
</script>

  <style>
.marker {
    background-image: url('https://spacebar.mints.cloud/public-assets/marcador-de-posicion');
    background-size: contain;
    height: 48px;
    width: 32px;
    cursor: pointer;
    background-repeat: no-repeat;
}
</style>
  
  <style lang="scss" scoped>
.locations-map-container {
  position: relative;
  .locations-map {
    width: 100%;
    min-width: 100%;
    aspect-ratio: 16/12;
    overflow: hidden;
    position: relative;
    @media (min-width:768.5px) {
      margin-top: -175px;
    }
  }
  &::before {
    position: absolute;
    content: "";
    left: -100px;
    top: 100px;
    width: 135px;
    height: 200px;
    background-image: url("https://sandbox.spacebar.mints.cloud/public-assets/arrow-l");
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
    @media (max-width: 768px) {
      display: none;
    }
    @media (max-width: 575px) {
      display: block;
      left: 50%;
      transform: translate(-50%, 0) rotate(30deg) scale(.8);
      top: calc( -1 * (36% - 20px));
    }
  }

}
.map-container {
  height: 100%; /* Altura necesaria para que el mapa sea visible */
}

@media (max-width: 767.5px) {
  .locations-map {
    width: 100%;
    aspect-ratio: initial;
    margin-top: 0;
  }
}
</style>
  
<style lang="scss">

.locations-map-container {
  .locations-map {
    padding-top: 60px;
    @media (max-width:768px) {
      padding-top: 0;
    }

    .mapboxgl-map {
      .mapboxgl-canvas-container{
        .mapboxgl-canvas{
          position: absolute;
          width: 100%;
        }
      }
    }
  }
}
</style>